import moment from 'moment'
import {
  AISummaryRange,
  GenerateAISummaryPayload,
} from 'src/interfaces/aiSummary.interface'

const DAY = 'YYYY-MM-DD'

/** Keep the page's exact instants and each boundary's local calendar day. */
export const toAISummaryRange = (
  start?: string | null,
  end?: string | null
): AISummaryRange | null => {
  if (!start || !end) return null
  const from = moment.parseZone(start, moment.ISO_8601, true)
  const to = moment.parseZone(end, moment.ISO_8601, true)
  if (!from.isValid() || !to.isValid()) return null
  const fromDay = from.format(DAY)
  const toDay = to.format(DAY)
  if (from.isAfter(to)) return null
  return {
    fromDate: from.toISOString(true),
    fromDay,
    toDate: to.toISOString(true),
    toDay,
  }
}

/** Same key the backend derives (periodSummary.periodKeyOf). */
export const aiSummaryPeriodKey = (range: AISummaryRange) =>
  `v2:${new Date(range.fromDate).toISOString()}/${new Date(range.toDate).toISOString()}`

/** V2 forwards exact inclusive boundaries; midnight is never widened. */
export const aiSummaryRangePayload = (
  range: AISummaryRange
): GenerateAISummaryPayload => ({
  fromDate: range.fromDate,
  periodVersion: 2,
  toDate: range.toDate,
})

/** "Feb 4, 2026 – Feb 17, 2026" — the backend's periodLabel format. */
export const aiSummaryRangeLabel = (range: AISummaryRange) =>
  `${moment.utc(range.fromDay).format('MMM D, YYYY')} – ${moment
    .utc(range.toDay)
    .format('MMM D, YYYY')}`

/** Clone mutable picker values and preserve both offsets (including DST). */
export const pickedAISummaryRange = (
  from: moment.Moment,
  to: moment.Moment
): AISummaryRange => ({
  fromDate: from.clone().startOf('day').toISOString(true),
  fromDay: from.format(DAY),
  toDate: to.clone().endOf('day').toISOString(true),
  toDay: to.format(DAY),
})
